import {
  Table,
  Modal,
  Button,
  notification,
  Form,
  Pagination,
  Select,
  Input,
} from "antd";
import React, { useState, useEffect } from "react";
import AllModalComponent from "../Modal/AllUserTableModal";
import {
  updateAllUser,
  getRequest,
  logUpdateUserInfo,
} from "../../util/APIUtils";
import "../Modal/AllUserTableModal.css";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const PAGE_SIZES = [5, 10, 20, 50, 100];

const AllUserTable = () => {
  const [dataSource, setDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [goToPage, setGoToPage] = useState("");
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [tcknSearchText, setTCKNSearchText] = useState("");
  const [tcknSearchedColumn, setTCKNSearchedColumn] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = dataSource;

    if (tcknSearchedColumn === "tckn" && tcknSearchText !== "") {
      filteredData = dataSource.filter((user) =>
        user.tckn.includes(tcknSearchText)
      );
    }

    setFilteredDataSource(filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize));
  }, [currentPage, pageSize, dataSource, tcknSearchText, tcknSearchedColumn]);




const updateAllUserRecord = (updatedItem) => {
  const { recordId, email } = updatedItem;
  const name = name;

  const oldRecord = dataSource.find((item) => item.recordId === recordId);
  const oldValue = oldRecord.email;

  const updatedDataSource = dataSource.map((item) => {
    if (item.recordId === recordId) {
      return {
        ...oldRecord,
        ...updatedItem,
      };
    }
    return item;
  });

    setDataSource(updatedDataSource);

    const requestBody = {
      recordId: recordId,
      oldValue: email,
      newValue: email,
      whichUser: name,
      time: new Date().toISOString(),
    };

    fetch(`/updateUser/${recordId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedItem),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Kullanıcı güncellenirken bir hata oluştu.");
        }
        notification.success({
          message: "Başarılı",
          description: "Kullanıcı başarıyla güncellendi.",
        });

        return fetch("/api/user_log/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Email değişikliği kaydedilirken bir hata oluştu.");
        }
        console.log("Email değişikliği başarıyla kaydedildi.");

        const logData = {
          recordId: recordId,
          oldValue: oldValue,
          newValue: email,
          whichUser: name,
          time: new Date().toISOString(),
        };

        return logUpdateUserInfo(logData);
      })
      .then(() => {
        console.log("Loglama başarıyla kaydedildi.");
      })
      .catch((error) => {
        console.error("Güncelleme veya kaydetme hatası:", error);
      });
  };

const fetchData = () => {
  getRequest(`/form/getAllUser?page=${currentPage - 1}&size=${pageSize}`)
    .then((response) => {
      setTotalDataCount(response.data.totalElements);
      setDataSource(response.data.content);
      setFilteredDataSource(response.data.content.slice(0, pageSize));
    })
    .catch((error) => {
      console.error("Veri çekme hatası:", error);
    });
};


const handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  setTCKNSearchText(selectedKeys[0]);
  setTCKNSearchedColumn(dataIndex);
  setCurrentPage(1);
};

const handleReset = (clearFilters) => {
  clearFilters();
  setTCKNSearchText("");
  setTCKNSearchedColumn("");
  setCurrentPage(1);
};

  const getColumnSearchProps = (dataIndex, searchText) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={searchText}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Ara
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Temizle
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      tcknSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tcknSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const onClose = () => {
    setModalVisible(false);
  };
  const handleCancel = () => {
    setModalVisible(false);
  };

  const showModal = (item) => {
    setSelectedItem(item);
    setModalVisible(true);
  };

  const handleGoToPageChange = (event) => {
    const { value } = event.target;
    if (/^\d*$/.test(value)) {
      setGoToPage(value);
    }
  };

  const handleGoToPageEnter = (event) => {
    if (event.key === "Enter") {
      const pageNumber = parseInt(goToPage);
      if (
        !isNaN(pageNumber) &&
        pageNumber >= 1 &&
        pageNumber <= Math.ceil(totalDataCount / pageSize)
      ) {
        setCurrentPage(pageNumber);
      }
    }
  };

 const handlePageChange = (page) => {
    setCurrentPage(page);
  };


const handlePageSizeChange = (value) => {
  setPageSize(value);
  setCurrentPage(1);

};



  const columns = [
    {
      title: "İsim-Soyisim",
      dataIndex: "name",
      key: "name",
      render: (text, record) => `${record.name} ${record.surname}`,
    },
    {
      title: "E-mail",
      dataIndex: "email",
      key: "email",
    },

    {
      title: "TCKN",
      dataIndex: "tckn",
      key: "tckn",
      width: "10%",
      sorter: true,
      ...getColumnSearchProps("tckn", "TCKN ile ara."),
      render: (text) =>
        tcknSearchedColumn === "tckn" ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[tcknSearchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        ),
    },
    {
      title: "Telefon Numarası",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
  render: (phoneNumber) => {
    if (phoneNumber) {
      const formattedPhoneNumber = `+90 (${phoneNumber.slice(
        0,
        3
      )}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
      return <span>{formattedPhoneNumber}</span>;
    }
    return <span>-</span>;
  }
  },

    {
      title: "Olusturulma Tarihi - Guncellenme Tarihi",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text, record) => {
        const updatedDate = record.updatedAt;
        const createdDate = record.createdAt;

        if (updatedDate) {
          return `${createdDate} ${updatedDate}`;
        } else {
          return createdDate;
        }
      },
    },

    {
      title: "",
      dataIndex: "order",
      key: "order",
      width: "5%",
      render: (_, record) =>
        dataSource.length >= 1 ? (
          <div style={{ textAlign: "center" }}>
            <a onClick={() => showModal(record)}>Düzenle</a>
          </div>
        ) : null,
    },
  ];

  return (
    <div className="page">
      <div className="tableAll">
        <Table
          dataSource={filteredDataSource}
          columns={columns}
          pagination={false}
        />
      </div>
      <div className="footer">
        <div className="toplam">Toplam {filteredDataSource.length} Kayıt</div>


        <div className="pagination-container">
          <Pagination
            current={currentPage}
            total={totalDataCount}
            pageSize={pageSize}
            onChange={handlePageChange}
          />
        </div>

        <div className="sayfa">
          <Select value={pageSize} onChange={handlePageSizeChange}>
            {PAGE_SIZES.map((size) => (
              <Select.Option key={size} value={size}>
                {size} /{" "}
                <span style={{ minWidth: "3ch", display: "inline-block" }}>
                  sayfa
                </span>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="git">
          <label style={{ minWidth: "3ch" }}>Git </label>
          <Input
            style={{ width: "7ch", height: "31px" }}
            value={goToPage}
            onChange={handleGoToPageChange}
            onKeyPress={handleGoToPageEnter}
          />
          <span style={{ display: "inline-block", minWidth: "5ch" }}>
            {" "}
            Sayfa
          </span>
        </div>
      </div>

      <AllModalComponent
        visible={modalVisible}
        onClose={handleCancel}
        selectedItem={selectedItem}
        onUpdate={updateAllUserRecord}
      />
    </div>
  );
};
export default AllUserTable;




// WEBPACK FOOTER //
// ./src/component/Table/AllUserTable.js